import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useGoBack = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasHistory = location.key !== 'default';

  return useCallback(
    (fallbackUrl?: string) => {
      if (hasHistory || !fallbackUrl) {
        navigate(-1);
        return;
      }
      navigate(fallbackUrl, { replace: true });
    },
    [hasHistory, navigate],
  );
};

export default useGoBack;
